import React from 'react';
import {
    CredentialResponse,
    GoogleLogin,
    GoogleOAuthProvider,
} from '@react-oauth/google';

export type GoogleButtonProps = {
    onSuccess: (response: CredentialResponse) => void;
    onFailure: VoidFunction;
    className?: string;
    width?: string;
    text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
};

const GoogleButton = ({
    onSuccess,
    onFailure,
    width,
    text = 'signin_with',
}: GoogleButtonProps): JSX.Element => {
    return (
        <GoogleOAuthProvider
            clientId={
                '1046744713396-280knck9n6i7rn2akn9utcidoog1n21s' +
                '.apps.googleusercontent.com'
            }>
            <GoogleLogin
                onSuccess={onSuccess}
                onError={onFailure}
                size="medium"
                theme="filled_blue"
                text={text}
                width={width}
            />
        </GoogleOAuthProvider>
    );
};

export { GoogleButton };
